import React from "react";
import { useSubscription } from "@apollo/client";
import moment from "moment";
import {PAYMENT_LIST} from "./PaymentsGQL.js";
import {Box,List} from "grommet";
import {DataGrid} from "@mui/x-data-grid";

function UserClubMatePayments(props) {
    const { data, loading } = useSubscription(PAYMENT_LIST);

    const transformData = (data) => {
        if (!data) return [];
        return data["clubmate_clubmatewallet_movementwallet"].map((event) => ({
            id: event?.id,
            quantity: event?.quantity + " €",
            datetime: moment(event?.datetime).format("DD-MM-YYYY HH:mm:ss"),
            serviceName: event?.clubmateservice_clubmateservice?.name || "",
            userName: event?.clubmatewallet_clubmatewallet?.usersregister_userregisters[0] ? `${event?.clubmatewallet_clubmatewallet?.usersregister_userregisters[0]?.name} ${event?.clubmatewallet_clubmatewallet?.usersregister_userregisters[0]?.surname} ${event?.clubmatewallet_clubmatewallet?.usersregister_userregisters[0]?.fiscal_code}` : "",
            package: event?.clubmatepackage_clubmatepackage?.name || ""
        }));
    };

    const rows = transformData(data) || [];

    const columnsEvents = [
        { field: 'datetime', headerName: 'Data e Ora', width: 200 },
        { field: 'quantity', headerName: 'Quantità', width: 100 },
        { field: 'userName', headerName: 'Utente', width: 300 },
        { field: 'serviceName', headerName: 'Servizio', width: 300 },
        { field: 'package', headerName: 'Pacchetto', width: 250 },
    ];

    const getRowClassName = (params) => {
        const quantity = params.row.quantity.split(" ")[0];
        if (quantity < 0) {
            return 'lowQuantity';
        } else if (quantity == 0) {
            return 'mediumQuantity';
        } else {
            return 'highQuantity';
        }
    };

    return (
        <Box overflow="auto" height="100%" width="100%" alignSelf='center' style={{marginTop:'40px'}} margin={"small"}>
            <div style={{ height: '80vh', width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columnsEvents}
                    loading={loading}
                    getRowClassName={getRowClassName}
                />
            </div>
        </Box>
    );
}

export default UserClubMatePayments;
